import TextLayout from "~/components/common/TextLayout";
import htmlContent from "~/data/legal-document/return.html?raw";

export default function ReturnsPolicyPage() {
  return <TextLayout title="Returns Policy" htmlContent={htmlContent} />;
}
